module.exports = __webpack_public_path__ + "static/img/icon-web-app.38b39ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-web-app.svg
// module id = 445
// module chunks = 0